import React, { useContext } from 'react'
import { Box, Grid } from '@chakra-ui/react'

import { PlatformError } from '~/utils/errors'
import { NotificationContext } from '../../../context/notification/NotificationContext'
import NotificationMessage from './NotificationMessage/NotificationMessage'

const NotificationBar: React.FC = () => {
  const context = useContext(NotificationContext)
  if (!context) {
    throw new PlatformError('NotificationBar must be used within a NotificationContext')
  }

  const { notifications, removeNotification } = context

  if (!notifications.length) {
    return null
  }

  return (
    <Box position="sticky" zIndex="sticky" top={0}>
      <Grid role="alert" aria-atomic="true">
        {notifications.map((notification) => (
          <NotificationMessage
            key={notification.id}
            richText={notification.richText}
            type={notification.type}
            text={notification.message}
            buttonLabel={notification.buttonLabel}
            onButtonClick={notification.onButtonClick}
            onCloseClick={() => removeNotification(notification.id)}
          />
        ))}
      </Grid>
    </Box>
  )
}

export default NotificationBar
